import type { ChangeEventHandler } from 'react'
import { COMMUNICATION_STYLES } from '../model/communicationStyles'
import s from './BreakUpOnboarding.module.css'

interface Props {
  name: string
  communicationStyle: string
  changeName: ChangeEventHandler<HTMLInputElement>
  changeStyle: ChangeEventHandler<HTMLInputElement>
}
export default function BreakUpIntroduction({ name, communicationStyle, changeName, changeStyle }: Props) {
  return <>
    <h1 className={s.heading}>Давайте познакомимся</h1>
    <p className={s.subtitle}>Чтобы обращаться к вам лично и поддерживать в нужный момент.</p>
    <label className={s.field}>
      <span>Как вас зовут?</span>
      <input type="text" value={name} onChange={changeName} placeholder="Ваше имя" autoComplete="given-name" />
    </label>
    <fieldset className={s.field}>
      <legend>Как вам сейчас лучше отвечать?</legend>
      <div className={`${s.options} ${s.styleOptions}`}>
        {Object.entries(COMMUNICATION_STYLES).map(([kind, { label }]) => (
          <label key={kind}>
            <input type="radio" name="communication-style" value={kind} checked={communicationStyle === kind} onChange={changeStyle} />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  </>
}
